export const appConfig = {
    HomeHero: {
        title: 'DEEPCRAFT™ AI Hub',
        description: `DEEPCRAFT™ AI Hub is a centralized place for Infineon customers
    to find DEEPCRAFT™ software for any Edge AI needs:
    platform, tools, solutions, and models all in one place`,
        sub_description: [
            'To find our Edge AI tools, search for the tools type.',
            'To find our production-grade off-the-shelf solutions, search for the solutions type.',
            'Other content types show you how to start developing or deploying your own AI project.',
        ],
    },
    AboutHero: {
        title: 'About the DEEPCRAFT™ AI Hub',
        description: [
            `The DEEPCRAFT™ AI Hub is a centralized place for Infineon customers to find software for any Edge AI needs. Organized by use case, it’s simple to navigate to the right platform, tools, and models that suit your needs, and you can get inspiration from open-source models and case studies across industrial, consumer and automotive applications.
`,
            'Designed to consolidate our Edge AI offering in one place, the DEEPCRAFT™ AI Hub provides a quicker path to market.',
        ],
    },
    footer_links: {
        'Terms of Use': 'https://www.infineon.com/legal/usage-terms',
        'Privacy Policy': 'https://www.infineon.com/legal/privacy-policy',
        Imprint: 'https://www.infineon.com/legal/imprint',
        About: '/about',
        '\u00A9 1999-2025 Infineon Technologies AG': '#',
    },
};
